import { injectReducers } from '../../store/reducers'
import AppLayout from '../../components/Layouts/AppLayout'
import { AsyncComponent } from '../../components/Layouts/RouterLayout'
import * as ROUTES from '../../constants/routes'

const getCountryContainer = store =>
  import(/* webpackChunkName: "Country" */ './reducers')
    .then(module => injectReducers(store, module.default))
    .then(() => import(/* webpackChunkName: "Country" */ './containers/CountryContainer'))
    .then(module => module.default)

export default (store) => ([
  {
    layout: AppLayout,
    exact: true,
    path: [
      ROUTES.COUNTRY_LIST_PATH,
    ],
    component: AsyncComponent(() => getCountryContainer(store))
  }
])
